import { Button, Input } from 'antd';
import React, { useState } from 'react';
import { useModalState } from '../../hooks/modalState';
import { useAppDispatch } from '../../hooks/redux';
import { manualConfirmEmailAction } from '../../redux/actions/userActions';
import { alertService } from '../../services';
import TransparencyCatalogModal from '../transparencyCatalogModal/TransparencyCatalogModal';

const ManualConfirmEmail = () => {
    const [state, setState] = useState('');
    const dispatch = useAppDispatch();
    const { isOpen, onToggle } = useModalState();

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState(event.currentTarget.value);
    };

    const handleClick = async () => {
        const { payload } = await dispatch(manualConfirmEmailAction(state));
        if (payload) {
            alertService.success('Email was confirmed');
        }
    };

    const handleOpen = () => {
        onToggle();
    };

    return (
        <>
            <Input onChange={onChange} />
            <Button onClick={handleClick}>Try Confirm</Button>
            <Button onClick={handleOpen}>Open</Button>
            <TransparencyCatalogModal isOpen={isOpen} />
        </>
    );
};

export default ManualConfirmEmail;
